import { render, staticRenderFns } from "./CoverPrint.vue?vue&type=template&id=c8d5f41e"
import script from "./CoverPrint.vue?vue&type=script&lang=js"
export * from "./CoverPrint.vue?vue&type=script&lang=js"
import style0 from "./CoverPrint.vue?vue&type=style&index=0&id=c8d5f41e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports